"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setPssSurveyLastSeenMutation = exports.setPssSurveyCompletedMutation = void 0;
var _apollo = require("../apollo");
var _PersistedApollo = require("../components/PersistedApollo");
const setPssSurveyLastSeenMutation = () => {
  (0, _PersistedApollo.getClient)().mutate({
    mutation: _apollo.setPssSurveyLastSeen
  });
};
exports.setPssSurveyLastSeenMutation = setPssSurveyLastSeenMutation;
const setPssSurveyCompletedMutation = () => {
  (0, _PersistedApollo.getClient)().mutate({
    mutation: _apollo.setPssSurveyLastCompleted
  });
};
exports.setPssSurveyCompletedMutation = setPssSurveyCompletedMutation;